import { useState } from "react";

/**
 * Genera una URL de Unsplash con un ancho específico manteniendo el hash,
 * el crop y otros params existentes. Si la URL no es Unsplash, se devuelve tal cual.
 */
function unsplashWithWidth(url, w) {
  if (typeof url !== "string" || !url.includes("images.unsplash.com")) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("w", String(w));
    u.searchParams.set("q", u.searchParams.get("q") || "78");
    u.searchParams.set("fm", u.searchParams.get("fm") || "webp");
    u.searchParams.set("auto", u.searchParams.get("auto") || "format");
    return u.toString();
  } catch {
    return url;
  }
}

/**
 * ResponsiveImg — genera automáticamente `srcset` con múltiples anchos y
 * pasa `sizes` para que el browser elija la mejor variante según viewport.
 *
 * Ejemplo:
 *   <ResponsiveImg
 *     src={IMG.classic}
 *     alt="Classic studs"
 *     widths={[400, 800, 1200, 1600]}
 *     sizes="(max-width: 640px) 92vw, (max-width: 1024px) 45vw, 640px"
 *     loading="lazy"
 *   />
 */
export function ResponsiveImg({
  src,
  alt = "",
  widths = [400, 800, 1200, 1600],
  sizes = "(max-width: 640px) 92vw, (max-width: 1024px) 45vw, 640px",
  className = "",
  onLoad,
  fadeIn = true,
  ...rest
}) {
  const [loaded, setLoaded] = useState(false);
  const isUnsplash = typeof src === "string" && src.includes("images.unsplash.com");
  const srcSet = isUnsplash
    ? widths.map((w) => `${unsplashWithWidth(src, w)} ${w}w`).join(", ")
    : undefined;
  const fallback = isUnsplash ? unsplashWithWidth(src, widths[widths.length - 1]) : src;

  return (
    <img
      src={fallback}
      srcSet={srcSet}
      sizes={isUnsplash ? sizes : undefined}
      alt={alt}
      onLoad={(e) => {
        setLoaded(true);
        onLoad?.(e);
      }}
      className={className}
      style={
        fadeIn
          ? {
              opacity: loaded ? 1 : 0,
              transition: "opacity 400ms cubic-bezier(0.22,1,0.36,1)",
            }
          : undefined
      }
      {...rest}
    />
  );
}

export default ResponsiveImg;
